import { useEffect } from "react";
import { publishUploadComplete, type UploadCompleteDetail } from "@/lib/upload-events";

// Opens ONE app-level EventSource to the server SSE stream and republishes
// upload-complete events to the module emitter. Mounted once (in AppShell).
// EventSource auto-reconnects on drop; if the stream is unavailable the app
// simply doesn't live-update — manual refresh still works (graceful floor).
export function useUploadEventStream(): void {
  useEffect(() => {
    let es: EventSource | null = null;
    try {
      es = new EventSource("/api/events"); // same-origin → session cookie sent automatically
    } catch {
      return; // EventSource unsupported / blocked — degrade silently
    }

    const onUploadComplete = (e: MessageEvent) => {
      try {
        const detail = JSON.parse(e.data) as UploadCompleteDetail;
        publishUploadComplete(detail);
      } catch {
        /* ignore malformed frames */
      }
    };

    es.addEventListener("upload-complete", onUploadComplete as EventListener);
    // onerror: EventSource handles reconnection itself; no action needed.
    es.onerror = () => {};

    return () => {
      es?.removeEventListener("upload-complete", onUploadComplete as EventListener);
      es?.close();
    };
  }, []);
}
